export default __webpack_public_path__ + "static/media/AllProductRightArrow.d4bf9340.svg";